import React, { Fragment } from "react";
import AddButton from "../../Campaign/AddButton";
import EnquireButton from "../../Campaign/EnquireButton";

export default ({ panel }) => {
    return (
        <div className={`panel panel--live-stream`}>
            <div className="panel__wrap">
                <div className="panel__inner">
                    <div className="panel__image">
                        <img src={panel.image} />
                    </div>
                    <div className="panel__content">
                        <a href={panel.link} className="panel__link">
                            <h5 className="panel__name">{panel.name}</h5>
                        </a>
                        <div className="panel__details">
                            {panel.city} | {panel.siteID}
                        </div>
                        <a href={panel.link} className="panel__link">Site Details</a>
                    </div>
                </div>
            </div>
        </div>
    );
};
